/**
 * @author YJH
 * 请求地址数据源，并做本地缓存
 */
export default (jsonString) => {
    if (!jsonString) {
        return false;
    }
    try {
        return JSON.parse(jsonString);
    }
    catch (err) {
        return false;
    }
};
